export class PaginatedResponse<T> {
  data: T[];

  total: number;

  constructor(response: Partial<PaginatedResponse<T>> = {}) {
    this.data = response.data ?? [];
    this.total = Number(response.total ?? 0);
  }
}
